import { Navigate, useParams } from "react-router-dom";
import { LoadingIndicator } from "@/components/application/loading-indicator/loading-indicator";
import { AdminPreviewContext } from "@/contexts/admin-preview-context";
import { useAcomAdmin } from "@/hooks/use-acom-admin";

interface RequireAdminPreviewProps {
    children: React.ReactNode;
}

/**
 * Route guard for /admin/preview/:clientId/home.
 * Requires the user to be an ACOM admin and the :clientId param to be a valid number.
 * Wraps children with AdminPreviewContext so API calls include X-Preview-Client-Id.
 */
export function RequireAdminPreview({ children }: RequireAdminPreviewProps) {
    const { isAcomAdmin, isLoaded } = useAcomAdmin();
    const { clientId } = useParams<{ clientId: string }>();

    if (!isLoaded) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <LoadingIndicator size="lg" label="Loading..." />
            </div>
        );
    }

    const parsedClientId = clientId ? Number(clientId) : NaN;
    if (!isAcomAdmin || isNaN(parsedClientId)) {
        return <Navigate to="/admin" replace />;
    }

    return <AdminPreviewContext.Provider value={{ previewClientId: parsedClientId }}>{children}</AdminPreviewContext.Provider>;
}
